import React from 'react';
import { Box } from '@material-ui/core';
import FsSmsCodeForm from 'ui-elements/forms/FsSmsCodeForm';
import { loginSmsCodeStep as loginLocales } from 'globals/locales/registration';
import { useAppContext } from 'contexts/AppContext';
import {
  FsHello,
  FsHelloWrapperBox,
  FsCenterBoxLine,
  FsCenterBoxSubTitle,
  FsCenterBoxTitle,
} from 'ui-elements/center-box-elements/FsCenterBoxElements.style-elements';
import { WrapperBox } from './LoginSmsCodeStep.style-elements';

interface LoginSmsCodeStepProps {
  phoneNumber?: string;
}

const LoginSmsCodeStep: React.FC<LoginSmsCodeStepProps> = ({ phoneNumber }) => {
  const { setIsVerified } = useAppContext();
  const handleOnGoNext = () => {
    setIsVerified(true);
  };

  return (
    <WrapperBox>
      <FsHelloWrapperBox>
        <FsHello>{loginLocales.hello}</FsHello>
      </FsHelloWrapperBox>
      <FsCenterBoxTitle>{loginLocales.title}</FsCenterBoxTitle>
      <FsCenterBoxSubTitle>
        {loginLocales.subTitle} {phoneNumber}
      </FsCenterBoxSubTitle>
      <FsCenterBoxLine />
      <Box marginTop={3}>
        <FsSmsCodeForm onGoNext={handleOnGoNext} withChangeNumber={false} />
      </Box>
    </WrapperBox>
  );
};

export default LoginSmsCodeStep;
